import script from "./VideoSplashScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoSplashScreen.vue?vue&type=script&setup=true&lang=js"

import "./VideoSplashScreen.vue?vue&type=style&index=0&id=6c367d08&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c367d08"]])

export default __exports__